// The records search dropdown's height follows the viewport (#13871): it
// may grow into the space it has, less a gutter, up to a share of the
// viewport, so a tall screen shows more of the up to fifty results.

/** Kept clear between the dropdown's edge and the viewport's edge. */
export const DROPDOWN_VIEWPORT_GUTTER_PX = 16;
/** The dropdown never takes more than this share of the viewport's height. */
const DROPDOWN_MAX_VIEWPORT_SHARE = 0.7;
/** The in-flow dropdown never drops below this. */
const DROPDOWN_MIN_HEIGHT_PX = 200;

/**
 * The dropdown's max height, given the space between the field and the
 * viewport edge it opens toward and the viewport's height: that space less
 * the gutter, at most 70% of the viewport, and never below 200px. The floor
 * wins over the space because the page or modal around the in-flow dropdown
 * scrolls to it. The portalled dropdown is fixed, so the page cannot scroll
 * to it: its caller also caps it at the space less the gutter.
 */
export function dropdownMaxHeight(
  spaceAvailablePx: number,
  viewportHeightPx: number
): number {
  return Math.max(
    DROPDOWN_MIN_HEIGHT_PX,
    Math.min(
      spaceAvailablePx - DROPDOWN_VIEWPORT_GUTTER_PX,
      DROPDOWN_MAX_VIEWPORT_SHARE * viewportHeightPx
    )
  );
}
